// src/layout/HeaderBar.tsx
import React, { useState } from 'react';
import { Layout, Button, Dropdown } from 'antd';
import { AppstoreOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import AppMenu from './AppMenu'; 
import { getAppUrlInfo } from '../utils/urls';

const { Header } = Layout;

const HeaderBar: React.FC<{ onDrawerOpen: () => void, showAppMenu: boolean }> = ({ onDrawerOpen, showAppMenu = true }) => {
  const [appMenuOpen, setAppMenuOpen] = useState(false);
  const { color:appColor } = getAppUrlInfo();

  /* logo link - always link to common dashboard */
  const logoLink = '/'; 

  return (
    <Header className="flex items-center justify-between px-4 fixed top-0 left-0 right-0 z-50 bg-white h-16"
      style={{
        background: '#ffffff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        borderBottom: `1px solid ${appColor}`
      }}>
      {/* Logo and Title */}
      <div className="flex items-center gap-2">
        <Link to={logoLink} className="flex items-center">
          <img src="https://parkinglap.com/assets/images/logo.png" alt="Logo" className="h-8" />
        </Link>
       {/*  <span className="text-sm font-medium text-gray-700"> {showAppMenu?`|  ${AppName} App`:""}</span> */}
      </div>

      {/* Right Section */}
      <div className="flex items-center gap-3">
        {showAppMenu && <Dropdown
          popupRender={() => <AppMenu />}
          trigger={['click']}
          open={appMenuOpen}
          onOpenChange={setAppMenuOpen}
          placement="bottomRight"
        >
          <Button shape="circle" title="Apps" icon={<AppstoreOutlined />} />
        </Dropdown>
        }
        <Button
          shape="circle"
          icon={<FontAwesomeIcon icon={faUserTie} />}
          title="User Profile"
          onClick={onDrawerOpen}
        />
      </div>
    </Header>
  );
};

export default HeaderBar;
